import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";

import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import MailLockIcon from '@mui/icons-material/MailLock';
import Typography from "@mui/material/Typography";

import PasswordResetForm from "./PasswordResetForm";
import { resetPassword } from "../../actions/authActions";

const PasswordResetPassword = (props) => {
    let params = useParams();
    const [passwordIsReset, setPasswordIsReset] = useState(false)

    const resetPassword = (formValues) => {
        const values = {
            'password': formValues.password,
            'password_confirm': formValues.password_confirm,
            'code': params.code
        }
        props.resetPassword(values);
        setPasswordIsReset(true);
    }

    const renderResetPassword = () => {
        return (
            <React.Fragment>
                <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                    <MailLockIcon />
                </Avatar>
                <Typography variant="h5">
                    Reset Password
                </Typography>
                <Box sx={{ mt: 3, maxWidth: 350 }}>
                    <PasswordResetForm onSubmit={resetPassword} />
                </Box>
            </React.Fragment>
        )
    }

    const renderPasswordIsReset = () => {
        return (
            <React.Fragment>
                <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                    <MailLockIcon />
                </Avatar>
                <Typography variant="h5">
                    Password is reset
                </Typography>
                <Link href="/login" variant="body2">
                    Login now
                </Link>
            </React.Fragment>
        )
    }

    return (
        <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            {!passwordIsReset ? renderResetPassword() : renderPasswordIsReset()}
        </Box>
    )
}

export default connect(null, { resetPassword })(PasswordResetPassword)